export default {
  "formstepform.basic.title": "Basic form",
  "formstepform.basic.description":
    "Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.",
  "formstepform.email.required": "Please enter your email!",
  "formstepform.email.wrong-format": "The email address is in the wrong format!",
  "formstepform.userName.required": "Please enter your userName!",
  "formstepform.password.required": "Please enter your password!",
  "formstepform.password.twice": "The passwords entered twice do not match!",
  "formstepform.strength.msg": "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  "formstepform.strength.strong": "Strength: strong",
  "formstepform.strength.medium": "Strength: medium",
  "formstepform.strength.short": "Strength: too short",
  "formstepform.confirm-password.required": "Please confirm your password!",
  "formstepform.phone-number.required": "Please enter your phone number!",
  "formstepform.phone-number.wrong-format": "Malformed phone number!",
  "formstepform.verification-code.required": "Please enter the verification code!",
  "formstepform.title.required": "Please enter a title",
  "formstepform.date.required": "Please select the start and end date",
  "formstepform.goal.required": "Please enter a description of the goal",
  "formstepform.standard.required": "Please enter a metric",
  "formstepform.form.get-captcha": "Get Captcha",
  "formstepform.captcha.second": "sec",
  "formstepform.form.optional": " (optional) ",
  "formstepform.form.submit": "Submit",
  "formstepform.form.save": "Save",
  "formstepform.email.placeholder": "Email",
  "formstepform.password.placeholder": "Password",
  "formstepform.confirm-password.placeholder": "Confirm password",
  "formstepform.phone-number.placeholder": "Phone number",
  "formstepform.verification-code.placeholder": "Verification code",
  "formstepform.title.label": "Title",
  "formstepform.title.placeholder": "Give the target a name",
  "formstepform.date.label": "Start and end date",
  "formstepform.placeholder.start": "Start date",
  "formstepform.placeholder.end": "End date",
  "formstepform.goal.label": "Goal description",
  "formstepform.goal.placeholder": "Please enter your work goals",
  "formstepform.standard.label": "Metrics",
  "formstepform.standard.placeholder": "Please enter a metric",
  "formstepform.client.label": "Client",
  "formstepform.label.tooltip": "Target service object",
  "formstepform.client.placeholder":
    "Please describe your customer service, internal customers directly @ Name / job number",
  "formstepform.invites.label": "Inviting critics",
  "formstepform.invites.placeholder": "Please direct @ Name / job number, you can invite up to 5 people",
  "formstepform.weight.label": "Weight",
  "formstepform.weight.placeholder": "Please enter weight",
  "formstepform.public.label": "Target disclosure",
  "formstepform.label.help": "Customers and invitees are shared by default",
  "formstepform.radio.public": "Public",
  "formstepform.radio.partially-public": "Partially public",
  "formstepform.radio.private": "Private",
  "formstepform.publicUsers.placeholder": "Open to",
  "formstepform.option.A": "Colleague A",
  "formstepform.option.B": "Colleague B",
  "formstepform.option.C": "Colleague C",
};
